<template>
  <div class="table">
    <slot name="header"></slot>
    <div class="table-body"
      :style="{height: bodyHeight}">
      <mescroll ref="mescroll" @init="initMescroll" :up="up" :down="down">
        <slot></slot>
      </mescroll>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import Mescroll from 'mescroll.js/mescroll.vue'
export default {
  name: 'QTableMescroll',
  components: {
    Mescroll
  },
  props: {
    height: [Number, String],
    downOption: Object,
    upOption: Object
  },
  computed: {
    bodyHeight() {
      const heightType = typeof this.height;
      if (!this.height || !['number', 'string'].includes(heightType)) {
        return '300px';
      }
      if (heightType === 'number') {
        return `${this.height}px`;
      } else {
        if (this.height.startsWith('calc')) {
          return this.height;
        } else if (!isNaN(parseInt(this.height, 10))) {
          return `${parseInt(this.height, 10)}px`;
        } else {
          '300px';
        }
      }
    },
    up() {
      return this.upOption;
    },
    down() {
      return this.downOption;
    }
  },
  data() {
    return {
      mescroll: null
    };
  },
  methods: {
    initMescroll(mescroll) {
      this.mescroll = mescroll;
    },
    scrollToTop(y) {
      if (this.mescroll) {
        this.mescroll.scrollTo(y||0);
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.table
  >>> .mescroll
    &::-webkit-scrollbar
      width 0
</style>